import { useQuery } from '@tanstack/react-query';
import { ScheduleConfigService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useHolidaysQuery = (holidayYear: number) =>
  useQuery({
    queryKey: queryKeys.holidays.list(),
    queryFn: () =>
      ScheduleConfigService.scheduleConfigServiceGetHolidays({
        path: {
          year: holidayYear,
        },
      }),
  });
